import { ApiClient } from "./api-client";

export function getRoles() {
  return ApiClient.getInstance().get('/role').catch((error) => {
    console.error('Error fetching user data:', error);
    throw error;
  });
}

export function getRole(id) {
  return ApiClient.getInstance().get('/role/:id', { urlParams: { id: id } }).catch((error) => {
    console.error('Error fetching user data:', error);
    throw error;
  });
}

export function createRole(name, acls, rooms, credits = 0) {
  return ApiClient.getInstance().post('/role', {
    name: name,
    acls: acls,
    rooms: rooms,
    credits: credits,
  }).catch((error) => {
    console.error('Error creating role:', error);
    throw error;
  });
}

export function updateRole(id, name, acls, rooms, credits) {
  return ApiClient.getInstance().put(`/role/${id}`, {
    name: name,
    acls: acls,
    rooms: rooms,
    credits: credits,
  }).catch((error) => {
    console.error('Error updating role:', error);
    throw error;
  });
}

export function deleteRole(id) {
  return ApiClient.getInstance().delete(`/role/${id}`).catch((error) => {
    console.error('Error deleting role:', error);
    throw error;
  });
}

export function getAcls(id) {
  return ApiClient.getInstance().get(`/role/${id}/acls`).catch((error) => {
    console.error('Error fetching user data:', error);
    throw error;
  });
}

export function getUsers(id) {
  return ApiClient.getInstance().get(`/role/${id}/users`).catch((error) => {
    console.error('Error fetching user data:', error);
    throw error;
  });
}